import * as React from 'react';
import { Filter } from 'lucide-react';
import { cn } from 'utils/utils';
import { PageHeaderWithFiltersContext } from './context';

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'>;

export const FiltersToggleButton = ({ ...props }: Props) => {
  const { open, setOpen } = React.useContext(PageHeaderWithFiltersContext);

  const toggleOpen = () => {
    setOpen((open) => !open);
  };

  return (
    <button onClick={toggleOpen} {...props}>
      <Filter
        className={cn(
          'h-4 w-4 text-[#1E293B] fill-none',
          open && 'fill-[#1E293B]'
        )}
      />
    </button>
  );
};
